import { ObjUtils, Iterable, IComparable } from "../Utils/ObjUtils";
import { List } from "../Utils/List";
import { HashSet } from "../Utils/HashSet";
import { TopoLinkMember } from "../Topology/TopoLinkMember";
import { TopoNode } from "../Topology/TopoNode";

export class TopoEdge {
	private _linkMembers: HashSet<TopoLinkMember>;

	public LocalNode: TopoNode;
	public RemoteNode:TopoNode;

	constructor(localNode: TopoNode = null, remoteNode: TopoNode = null) {
		this._linkMembers = new HashSet<TopoLinkMember>();

		this.LocalNode = localNode;
		this.RemoteNode = remoteNode;
	}

	public get LocalLinkMember(): TopoLinkMember {
		if (this.LocalNode == null)
			return null;

		return this.FindLinkMember(this.LocalNode);
	}

	public get RemoteLinkMember(): TopoLinkMember {
		if (this.RemoteNode == null)
			return null;

		return this.FindLinkMember(this.RemoteNode);
	}

	private FindLinkMember(topoNode: TopoNode): TopoLinkMember {
		let topoLinkMember: TopoLinkMember = null;

		if (topoNode != null) {
			this._linkMembers.Some((linkMember: TopoLinkMember) => {
				if (linkMember.LocalConnection.Node == topoNode) {
					topoLinkMember = linkMember;
					return true;
				}
				else {
					return false;
				}
			}, this);
		}

		return topoLinkMember;
	}

	public AddLinkMember(link: TopoLinkMember): void {
		this._linkMembers.Add(link);
	}

	public get Links(): List<TopoLinkMember> {
		return this._linkMembers.ToList();
	}

	public ContainsNode(node: TopoNode): boolean {
		return this.LocalNode == node || this.RemoteNode == node;
	}

	public PeerNode(node: TopoNode): TopoNode {
		if (ObjUtils.Equals(this.LocalNode, node))
			return this.RemoteNode;
		else
			return this.LocalNode;
	}
}
 